<template>
  <v-sheet elevation="3" class="auto-padding pt-4 pb-2">
    <div class="flex items-center justify-start gap-10 mb-2">
      <div>
        <h2 class="text-3xl font-saira font-medium flex items-center">
          {{ title }}
          <!-- <v-icon class="ml-4" small>fas fa-sort</v-icon> -->
        </h2>
      </div>

      <div>
        <slot />
      </div>
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "title",
    },
  },
};
</script>

<style>
</style>